import React, { useState, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import { Avatar, Typography, useTheme } from "@material-ui/core";
import useStyles from "../../styles";
import SidePannelList from "../CustomComponent/SidePannelList";
// import CoachingLogo from "../images//headericon/coachinglogo.png";
import imagePath from "../images/profile/Photo.png";
import axios from "axios";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { decryptData } from "../../crypto";
import { useProfile } from "../../context/ProfileContext";

export default function SidePannel({
  menuCollapse,
  globalProfileImageState,
  header,
}) {
  const classes = useStyles();

  const [clientName, setClientName] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const { profile } = useProfile();

  const [instituteName, setInstitutename] = useState("");

  const fetchDataFromAPI = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth/profile`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200) {
        const data = response.data.user;
        setClientName(data.user_information.contact_person_name);
      } else {
        console.log("data not found");
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
    }
  };

  useEffect(() => {
    fetchDataFromAPI();
    // if (profile) {
    //   const data = profile.data.user;
    //   setClientName(data.user_information.contact_person_name);
    // }
  }, []);

  const [currentDate, setCurrentDate] = useState(new Date());
  // const currentDate = new Date();

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date()); // Use setCurrentDate to update the state
    }, 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const currentMonth = currentDate.toLocaleString("default", {
    month: "short",
  });
  const currentDay = currentDate.getDate();
  const currentYear = currentDate.getFullYear();

  let currentTime = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  }); // 11:18 AM

  const getInitials = (name) => {
    return name && name.trim() ? name.charAt(0).toUpperCase() : "A";
  };
  const theme = useTheme();
  const imageStyle = {
    height: "80px",
    borderRadius: "6px",
    padding: "0.5rem",
    marginLeft: "0.5rem",
    marginRight: "1rem",
  };
  return (
    <>
      <Paper
        className={`${classes.w100} ${classes.dflex} ${classes.h89vh} ${classes.flexdirectioncolumn} ${classes.boxshadow1}`}
      >
        <div
          // className={classes.profilename}
          className={`${classes.bgdarkblue1} ${classes.p2_2} ${classes.h62px} ${classes.textcolorwhite} ${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
        >
          {menuCollapse ? (
            <Avatar
              style={{
                width: theme.spacing(4.5),
                height: theme.spacing(4.5),
                fontSize: "1.5rem",
                backgroundColor: "lightyellow",
                color: "purple",
                fontFamily: '"Roboto", sans-serif',
              }}
            >
              {getInitials(clientName)}
            </Avatar>
          ) : (
            <div>
              {globalProfileImageState.image ? (
                <img
                  src={globalProfileImageState.image} // Use defaultLogo if clientLogo is not available
                  width="150px"
                  height="55px"
                  alt="img of client"
                />
              ) : (
                <Avatar
                  src={imagePath} // Use defaultLogo if clientLogo is not available
                  width="100%"
                  alt="img of client"
                />
              )}
            </div>
          )}
        </div>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          scrollButtons="off"
          indicatorColor="none"
          aria-label="Vertical tabs example"
          className={`${classes.w90} ${classes.m0auto}  `}
        >
          <SidePannelList menuCollapse={menuCollapse} MainHeading={header} />
        </Tabs>
      </Paper>
      <div
        className={`${!menuCollapse && classes.px1} ${classes.py0_56} ${
          classes.bgsky
        } `}
      >
        <Typography
          variant="h6"
          className={`${classes.fontfamilyoutfit} ${classes.fontsize4} ${classes.fw600} ${classes.textcolorwhite} ${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
        >
          <AccessTimeIcon className={`${classes.mr0_3}`} />{" "}
          <span className={menuCollapse && classes.dnone}>Standard Time: </span>
        </Typography>
        <Typography
          variant="h6"
          className={`${menuCollapse && classes.dblock} ${
            classes.fontfamilyoutfit
          } ${classes.fontsize3} ${classes.textcolorwhite} ${classes.dflex} ${
            classes.alignitemscenter
          } ${classes.justifycenter} ${classes.textaligncenter}`}
        >
          {`${currentDay} ${currentMonth} ${currentYear}`}{" "}
          <span className={!menuCollapse && classes.ml0_5}>
            {" "}
            {currentTime}{" "}
          </span>
        </Typography>
      </div>
    </>
  );
}
